export default "/images/vendor/@coreui/icons/svg/flag/cif-cy.svg?2855be200179b1c8e8694f612ebef5ba";